module.exports = __webpack_public_path__ + "media/images/Groupe 175-3b72ed1acd5417a305d62df9348a6cdd.svg";